export default "__VITE_ASSET__D9CxM_co__"